import { useState } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import Page from "../Page";
import StatisticsSection from "./StatisticsSection";
import VerificationQueueTab from "./VerificationQueueTab";
import ChargerInventoryTab from "./ChargerInventoryTab";

const MobileCpoOnboarding = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Page title="CPO Onboarding">
      <Box sx={{ px: { xs: 2, md: 3 }, pb: 4 }}>
        <Typography variant="h5" fontWeight={700} mb={3}>
          Statistics
        </Typography>

        <Box mb={3}>
          <StatisticsSection />
        </Box>

        <Box
          sx={{
            display: "inline-flex",
            bgcolor: "action.selected",
            borderRadius: "50px",
            p: 0.5,
            mb: 2,
          }}
        >
          <Tabs
            value={activeTab}
            onChange={(_, v) => setActiveTab(v)}
            TabIndicatorProps={{ style: { display: "none" } }}
            sx={{
              minHeight: 36,
              "& .MuiTab-root": {
                textTransform: "none",
                fontWeight: 500,
                borderRadius: "50px",
                minHeight: 36,
                px: 2.5,
                py: 0.5,
                color: "text.secondary",
                "&.Mui-selected": {
                  bgcolor: "background.paper",
                  color: "text.primary",
                  boxShadow: "0 1px 4px rgba(0,0,0,0.18)",
                },
              },
            }}
          >
            <Tab label="Verification queue" />
            <Tab label="Charger inventory" />
          </Tabs>
        </Box>

        {activeTab === 0 && <VerificationQueueTab />}
        {activeTab === 1 && <ChargerInventoryTab />}
      </Box>
    </Page>
  );
};

export default MobileCpoOnboarding;
